<template>
  <div class="orderGoods ">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
		@click="skip(cart.product_id)"
      >
        <div class="pictrue">
          <img :src="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
			<div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1 suk" v-if="cart.productInfo.attrInfo">
            <p>{{ cart.productInfo.attrInfo.suk }}</p>
			<p v-if="cart.spec_values">{{ cart.spec_values }}</p>
          </div>
          <div class="money font-color-red">
            ￥{{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
          </div>
		  <div v-if="cart.refund.display && scan != 0" class="evaluate" @click.stop="$router.push(cart.refund.jump_url)">{{ cart.refund.name }}</div>
          <div
            class="evaluate"
            v-else-if="evaluate === 3 && cart.is_reply == 0 && scan != 0"
            @click.stop="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
          <div class="evaluate_text"
            v-else-if="evaluate === 3 && cart.is_reply == 1 && scan != 0"
          >
            已评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
	scan: Number
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {
	  skip(productId){
      if(productId == 205) {
        this.$router.push("/product/detail/"+productId);
        return;
      }
		  this.$router.push("/detail/"+productId)
	  }
  }
};
</script>
<style scoped>
.suk p{overflow: hidden; text-overflow: ellipsis;}
.goodWrapper .item{height: auto;padding-top: 0.2rem;padding-bottom: 0.2rem;}
</style>

